import React from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import icon from '../../mapIcon.png';

class MapContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          showingInfoWindow: false,
          activeMarker: {},
          selectedPlace: {},
        }
        
        // binding this to event-handler functions
        this.onMarkerClick = this.onMarkerClick.bind(this);
        this.onMapClicked = this.onMapClicked.bind(this);
      }
      
      onMarkerClick = (props, marker, e) => {
        this.setState({
          selectedPlace: props,
          activeMarker: marker,
          showingInfoWindow: true
        });
      }
     
      onMapClicked(props) {
        if (this.state.showingInfoWindow) {
          this.setState({
            showingInfoWindow: false,
            activeMarker: null
          })
        }
      }

  render() {
    return (
      <div id="map">
        <Map
          google={this.props.google}
          style={{ width: "100%", height: "400px" }}
          className={"map"}
          initialCenter={{
            lat: 30.058227,
            lng: 31.359683
          }}
          zoom={18}
          onClick={this.onMapClicked}
        >
          <Marker
            title={"مركز المهندس لصيانة السيارات"}
            name={"مركز المهندس لصيانة السيارات"}
            position={{ lat: 30.058227, lng: 31.359683 }}
            onClick={this.onMarkerClick}
            icon={{
                url: icon
              }}
          />
          <InfoWindow
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}>
            <div>
              <h1>{this.state.selectedPlace.name}</h1>
            </div>
          </InfoWindow>
        </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyCfKJTC-aAanHusXcKIfSgyM-GpBCIPS1U"
})(MapContainer);



// WEBPACK FOOTER //
// ./src/components/about/MapContainer.js